import React, { Component } from 'react';
import '../App.css';

//theming
import {teal700,blue} from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

//components
import Paper from 'material-ui/Paper';

//custom components
import Education from './Education'
import Experience from './Experience'
import ReferencesCard from './ReferencesCard'
import SkillCard from './SkillCard'
import SummaryCard from './SummaryCard'

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: teal700,
    primary2Color: blue
  },
});
const styles = {
  appbar:{

  },
  paper:{
    maxWidth:800,
    margin:'auto',
    marginTop:10,
    marginBottom:10,
    textAlign:'left',
    backgroundColor:'rgba(255,255,255,0)',
  },
  headline: {
    fontSize: 20,
    fontWeight: 400,
    textAlign:'center',
    margin:0,
  },
  tab_inkbar:{
    backgroundColor:'rgb(212,175,55)',
  }
};

class ResumeSingle extends Component {
  constructor(props){
    super(props);
    this.state=props.appState;
  }
  componentWillMount(){
    this.setState({slideIndex:0});
  }
  handleTabChange = (value) => {
    this.setState({
      slideIndex: value,
    });
  };

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div>
          <div className="App-resume">
            <div className="App-header-resume">
              <h1 className="margin-resume">John S. Ma</h1>
              <p className="margin-resume">
                <a
                  className="email-link-resume"
                  href="mailto:johnma30@gmail.com?Subject=Resume%20Inquiry" target="_top"
                >
                  johnma30@gmail.com
                </a>
                <br />
                <a
                  className="email-link-resume"
                  href="http://www.johnsma.com" target="_blank" rel="noopener noreferrer"
                >
                  www.johnsma.com
                </a>
              </p>
            </div>
            <div>
              <h2 style={{...styles.headline,...{paddingTop:0}}}>Summary</h2>
              <Paper
                zDepth={0}
                style={styles.paper}
              >
                <SummaryCard />
              </Paper>
              <h2 style={{...styles.headline,...{paddingTop:0}}}>Experience</h2>
              <Paper
                zDepth={0}
                style={styles.paper}
              >
                <Experience
                  showCarrot={false}
                />
              </Paper>
              <h2 style={styles.headline}>Education</h2>
              <Paper
                zDepth={0}
                style={styles.paper}
              >
                <Education
                  showCarrot={false}
                />
              </Paper>
              <h2 style={{...styles.headline,...{paddingTop:0}}}>Skills</h2>
              <Paper
                zDepth={0}
                style={styles.paper}
              >
                <SkillCard />
              </Paper>
              <h2 style={styles.headline}>References</h2>
              <Paper
                zDepth={0}
                style={styles.paper}
              >
                <ReferencesCard />
              </Paper>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default ResumeSingle;



// WEBPACK FOOTER //
// ./src/components/ResumeSingle.js